import React from "react";
import "@/stylesheets/components/generic/edbuttoncomponent/edButton.scss";
import { Link } from "react-router-dom";
import { hyperlink, trackCtaClick } from "../../../optiblackhelperfunction";

export interface IBtnProps {
  value?: string | React.ReactElement;
  returnValue?: string | number;
  // value - display text of the button, react components can also be passed if required
  type?: "button" | "submit" | "reset"; // the three types of button
  btnTyp:
    | "tomato-red"
    | "light-navy"
    | "dusty-orange"
    | "white-twenty"
    | "kelly-green-two"
    | "blue-one"
    | "grey-one"
    | "link"
    | "blue-link"
    | "green-btn"
    | "red-btn"
    | "midnight-blue"
    | "dark-peach"
    | "dark-peach-rounded"
    | "grey-suit" // color of the button
    | "midnight-blue-border"
    | "midnight-blue-underline-border"
    | "blood-red"
    | "blood-red-border"
    | "black_one"
    | "monochrome-light-grey"
    | "midnight-blue-underline"
    | "white-one"
    | "white-rounded"
    | "midnight-blue-no-underline"
    | "dusty-grey-underline"
    | "black-underline"
    | "tomato"
    | "green-underline"
    | "secondary-gray-border"
    | "monochrome-light-grey-border"
    | "vivid-green-border"
    | "white-underline"
    | "aqua-white-border"
    | "link-hover"
    | "dark-peach-hover"
    | "dark-peach-rounded-border";

  slim?: boolean; // pass this prop if button is slim
  disabled?: boolean; // if disabled then pass true
  className?: string; // optional className if additional CSS needs to be provided
}

export interface IEdIconBtnProps extends IBtnProps, IEdButtonProps {
  btnIcon: string;
}

export interface IEdButtonProps extends IBtnProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void; // the function to be called onClick
}

interface IEdLinkButtonProps extends IBtnProps {
  LinkHref: string;
  target?: "_blank" | "_self";
}

const EdButton: React.FC<IEdButtonProps> = (props: IEdButtonProps) => {
  // Checks if button or action
  const btnOrActionClass =
    props.btnTyp === "white-one" ||
    props.btnTyp === "tomato" ||
    props.btnTyp === "tomato-red" ||
    props.btnTyp === "light-navy" ||
    props.btnTyp === "dusty-orange" ||
    props.btnTyp === "white-twenty" ||
    props.btnTyp === "kelly-green-two" ||
    props.btnTyp === "blue-one" ||
    props.btnTyp === "grey-one" ||
    props.btnTyp === "green-btn" ||
    props.btnTyp === "red-btn" ||
    props.btnTyp === "midnight-blue" ||
    props.btnTyp === "midnight-blue-border" ||
    props.btnTyp === "midnight-blue-underline" ||
    props.btnTyp === "midnight-blue-underline-border" ||
    props.btnTyp === "grey-suit" ||
    props.btnTyp === "midnight-blue-no-underline" ||
    props.btnTyp === "monochrome-light-grey" ||
    props.btnTyp === "black_one" ||
    props.btnTyp === "blood-red" ||
    props.btnTyp === "blood-red-border" ||
    props.btnTyp === "dark-peach" ||
    props.btnTyp === "dark-peach-rounded" ||
    props.btnTyp === "white-rounded" ||
    props.btnTyp === "dusty-grey-underline" ||
    props.btnTyp === "black-underline" ||
    props.btnTyp === "monochrome-light-grey-border" ||
    props.btnTyp === "white-underline" ||
    props.btnTyp === "link-hover" ||
    props.btnTyp === "dark-peach-rounded-border" ||
    props.btnTyp === "dark-peach-hover"
      ? "button"
      : "";

  return (
    <button
      type={props.type}
      className={`ed_button ${props.btnTyp} ${btnOrActionClass}${
        props.slim ? " slim" : ""
      }${props.disabled ? " disabled" : ""}${
        props.className ? ` ${props.className}` : ""
      }`}
      value={props.returnValue}
      onClick={(e) => {
        // Call the original onClick function
        if (props.onClick) {
          props.onClick(e);
        }
        const value =
          typeof props.value === "string"
            ? props.value
            : React.Children.toArray(props.value)[0]?.toString();
        // Call the new function
        trackCtaClick("button", value, "click");
      }}
      disabled={props.disabled}
    >
      {props.value}
    </button>
  );
};

export const EdButtonIcon: React.FC<IEdIconBtnProps> = (
  props: IEdIconBtnProps,
) => {
  // Checks if button or action
  const btnOrActionClass =
    props.btnTyp === "tomato-red" ||
    props.btnTyp === "light-navy" ||
    props.btnTyp === "dusty-orange" ||
    props.btnTyp === "white-twenty" ||
    props.btnTyp === "kelly-green-two" ||
    props.btnTyp === "blue-one" ||
    props.btnTyp === "grey-one"
      ? "button"
      : "";

  return (
    <button
      type={props.type}
      className={`ed_button ${props.btnTyp} ${btnOrActionClass}${
        props.slim ? " slim" : ""
      }${props.disabled ? " disabled" : ""}${
        props.className ? ` ${props.className}` : ""
      }`}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.btnIcon ? <i className={props.btnIcon}></i> : props.value}
    </button>
  );
};

export const EdLinkButton: React.FC<IEdLinkButtonProps> = (
  props: IEdLinkButtonProps,
) => {
  // Checks if button or action
  const btnOrActionClass =
    props.btnTyp === "tomato-red" ||
    props.btnTyp === "light-navy" ||
    props.btnTyp === "dusty-orange" ||
    props.btnTyp === "white-twenty" ||
    props.btnTyp === "kelly-green-two" ||
    props.btnTyp === "blue-one" ||
    props.btnTyp === "grey-one"
      ? "button"
      : "";

  return (
    <Link
      to={props.LinkHref}
      type={props.type}
      className={`ed_button common_button ib  ${
        props.btnTyp
      } ${btnOrActionClass}${props.slim ? " slim" : ""}${
        props.disabled ? " disabled" : ""
      }${props.className ? ` ${props.className}` : ""}`}
      onClick={() => {
        const value = props.value;
        hyperlink("hyperlink", "button name", "click");
      }}
    >
      {props.value}
    </Link>
  );
};

export const EdALinkButton: React.FC<IEdLinkButtonProps> = (
  props: IEdLinkButtonProps,
) => {
  // Checks if button or action
  const btnOrActionClass =
    props.btnTyp === "tomato-red" ||
    props.btnTyp === "light-navy" ||
    props.btnTyp === "dusty-orange" ||
    props.btnTyp === "white-twenty" ||
    props.btnTyp === "kelly-green-two" ||
    props.btnTyp === "blue-one" ||
    props.btnTyp === "grey-one"
      ? "button"
      : "";
  return (
    <a
      target={props.target ? props.target : "_blank"}
      rel="noopener noreferrer"
      href={props.LinkHref}
      type={props.type}
      className={`ed_button ib ${props.btnTyp} ${btnOrActionClass}${
        props.slim ? " slim" : ""
      }${props.disabled ? " disabled" : ""}${
        props.className ? ` ${props.className}` : ""
      }`}
    >
      {props.value}
    </a>
  );
};

export default EdButton;
